import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { HttpActionConfig } from './HttpActionConfig';
import { HttpActionNode, httpActionVisualDefinition } from './HttpActionNode';
import {
  HttpActionConfigType,
  defaultHttpConfig,
  validateHttpConfig,
  getHttpPreviewText,
} from './schema';

export { HttpActionNode } from './HttpActionNode';
export { HttpActionConfig } from './HttpActionConfig';
export type { HttpActionConfigType } from './schema';

/** Full definition for the registry */
export const httpActionDefinition: NodeDefinition<HttpActionConfigType> = {
  ...httpActionVisualDefinition,
  category: 'action',
  paletteGroup: 'HTTP',
  NodeComponent: HttpActionNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: HttpActionConfig,
  defaultConfig: () => ({ ...defaultHttpConfig }),
  validateConfig: validateHttpConfig,
  getPreviewText: getHttpPreviewText,
};
